import type { APIRequestBody } from './base-fetch';
import { get, post, remove } from './base-fetch';

export type AutoEnhanceConfigPayload =
  APIRequestBody<'/api/v4/projects/{projectId}/auto-enhance/config'>;

export type AutoEnhanceConfigResponse =
  APIRequestBody<'/api/v4/projects/{projectId}/auto-enhance/config'>;

export const getAutoEnhanceConfig = async (
  projectId: string,
): Promise<AutoEnhanceConfigResponse> =>
  get<AutoEnhanceConfigResponse>(
    `/v4/projects/${projectId}/auto-enhance/config`,
  );

export const upsertAutoEnhanceConfig = async (
  projectId: string,
  payload: AutoEnhanceConfigPayload,
): Promise<AutoEnhanceConfigResponse> =>
  post<AutoEnhanceConfigResponse, AutoEnhanceConfigPayload>(
    `/v4/projects/${projectId}/auto-enhance/config`,
    payload,
  );

export const disableAutoEnhance = async (
  projectId: string,
): Promise<{ success: boolean }> =>
  remove<{ success: boolean }>(`/v4/projects/${projectId}/auto-enhance/config`);
